import React, { useState, useEffect } from "react";
import axios from "axios";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import "leaflet/dist/leaflet.css";
import L from "leaflet";

// Fix for default marker icons in Leaflet


const StoreLocator = ({ token }) => {
  const [locations, setLocations] = useState([]);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedLocation, setSelectedLocation] = useState(null);
  delete L.Icon.Default.prototype._getIconUrl;
  L.Icon.Default.mergeOptions({
    iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
    iconUrl: require("leaflet/dist/images/marker-icon.png"),
    shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
  });
  // Fetch locations from the backend
  useEffect(() => {
    axios
      .get("https://supplement-app-d151447d38d4.herokuapp.com/api/locations", {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        setLocations(response.data);
      })
      .catch((error) => {
        console.error("Error fetching locations:", error);
      });
  }, [token]);

  // Group locations by city
  const groupLocationsByCity = () => {
    const grouped = {};
    locations.forEach((location) => {
      if (!grouped[location.city]) {
        grouped[location.city] = [];
      }
      grouped[location.city].push(location);
    });
    return grouped;
  };

  const groupedLocations = groupLocationsByCity();

  // Handle city selection
  const handleCitySelect = (city) => {
    setSelectedCity(city);
    setSelectedLocation(null); // Reset selected location when a new city is selected
  };

  // Handle location selection
  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-2xl font-bold mb-6">Store Locator</h1>

      {/* City Selection */}
      <div className="mb-6">
        <h2 className="text-xl font-semibold mb-4">Select a City</h2>
        <div className="flex flex-wrap gap-2">
          {Object.keys(groupedLocations).map((city) => (
            <button
              key={city}
              onClick={() => handleCitySelect(city)}
              className={`px-4 py-2 rounded ${
                selectedCity === city
                  ? "bg-blue-500 text-white"
                  : "bg-white text-gray-700 border border-gray-300"
              }`}
            >
              {city}
            </button>
          ))}
        </div>
      </div>

      {/* Store List for Selected City */}
      {selectedCity && (
        <div className="mb-6">
          <h2 className="text-xl font-semibold mb-4">Stores in {selectedCity}</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {groupedLocations[selectedCity].map((location) => (
              <div
                key={location._id}
                onClick={() => handleLocationSelect(location)}
                className={`p-4 border rounded cursor-pointer ${
                  selectedLocation?._id === location._id
                    ? "bg-blue-50 border-blue-500"
                    : "bg-white border-gray-300"
                }`}
              >
                <h3 className="text-lg font-semibold">{location.name}</h3>
                <p>{location.address}</p>
                <p>Hours: {location.operation_hours}</p>
                <p>Contact: {location.contactNumber}</p>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* Selected Store Details and Map */}
      {selectedLocation && (
        <div className="mt-6">
          <h2 className="text-xl font-semibold mb-4">Store Details</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Store Details */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold">{selectedLocation.name}</h3>
              <p>{selectedLocation.address}</p>
              <p>City: {selectedLocation.city}</p>
              <p>Zip Code: {selectedLocation.zipCode}</p>
              <p>Hours: {selectedLocation.operation_hours}</p>
              <p>Contact: {selectedLocation.contactNumber}</p>
            </div>

            {/* Map */}
            <div className="bg-white p-6 rounded-lg shadow-md">
              <MapContainer
                center={[
                  parseFloat(selectedLocation.latitude),
                  parseFloat(selectedLocation.longitude),
                ]}
                zoom={13}
                style={{ height: "400px", width: "100%" }}
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                />
                <Marker
                  position={[
                    parseFloat(selectedLocation.latitude),
                    parseFloat(selectedLocation.longitude),
                  ]}
                >
                  <Popup>{selectedLocation.name}</Popup>
                </Marker>
              </MapContainer>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default StoreLocator;